import { c as _c } from "react/compiler-runtime";
import { getOrgGraphsByGraphIdSearchOptions } from '@onefootprint/fetch-dashboard';
import { IcoSearch16 } from '@onefootprint/icons';
import { Command, IconButton, useShortcut } from '@onefootprint/ui';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSidebar, useStore } from '@/components/playbook-builder';
import { useGetStaticNodeInfo } from '@/components/playbook-builder/components/base-node/hooks/use-get-static-node-info';
import NodeCard from '@/components/playbook-builder/components/node-card';
import { createSearchIndex, MIN_SEARCH_LENGTH, searchNodes } from './utils/search-nodes';
const Search = () => {
  const $ = _c(47);
  const {
    t
  } = useTranslation("playbook-builder");
  const {
    data: t0
  } = useStore();
  const {
    graph
  } = t0;
  const {
    open: openNode
  } = useSidebar();
  const [isOpen, setIsOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const getNodeInfo = useGetStaticNodeInfo();
  let t1;
  if ($[0] !== graph.id) {
    t1 = getOrgGraphsByGraphIdSearchOptions({
      path: {
        graphId: graph.id
      }
    });
    $[0] = graph.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isOpen || $[3] !== t1) {
    t2 = {
      ...t1,
      enabled: isOpen
    };
    $[2] = isOpen;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data,
    isError
  } = useQuery(t2);
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      keys: ["Meta", "k"],
      onShortcut: () => setIsOpen(true),
      onEscKeyDown: () => {
        setIsOpen(false);
        setSearchValue("");
      }
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useShortcut(t3);
  let T0;
  let t10;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[6] !== data || $[7] !== getNodeInfo || $[8] !== isError || $[9] !== isOpen || $[10] !== openNode || $[11] !== searchValue || $[12] !== t) {
    let t11;
    bb0: {
      if (!data?.nodes) {
        t11 = null;
        break bb0;
      }
      t11 = createSearchIndex(data.nodes);
    }
    const fuse = t11;
    let t12;
    bb1: {
      if (!fuse) {
        t12 = [];
        break bb1;
      }
      t12 = searchNodes(fuse, searchValue);
    }
    const results = t12;
    let t13;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = () => {
        setIsOpen(false);
        setSearchValue("");
      };
      $[21] = t13;
    } else {
      t13 = $[21];
    }
    const close = t13;
    let t14;
    if ($[22] !== openNode || $[23] !== searchValue) {
      t14 = nodeId => {
        openNode(nodeId, {
          focusNode: true,
          searchTerm: searchValue
        });
        close();
      };
      $[22] = openNode;
      $[23] = searchValue;
      $[24] = t14;
    } else {
      t14 = $[24];
    }
    const handleSelect = t14;
    let t15;
    if ($[25] !== t) {
      t15 = t(_temp);
      $[25] = t;
      $[26] = t15;
    } else {
      t15 = $[26];
    }
    let t16;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
      t16 = () => setIsOpen(true);
      $[27] = t16;
    } else {
      t16 = $[27];
    }
    if ($[28] !== t15) {
      t10 = <IconButton icon={IcoSearch16} aria-label={t15} variant="outline" size="compact" onClick={t16} />;
      $[28] = t15;
      $[29] = t10;
    } else {
      t10 = $[29];
    }
    T0 = Command.Container;
    t4 = isOpen;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = open => !open && close();
      $[30] = t5;
    } else {
      t5 = $[30];
    }
    t6 = false;
    t7 = "max-md:w-[calc(100vw-32px)]";
    let t17;
    if ($[31] !== t) {
      t17 = t(_temp2);
      $[31] = t;
      $[32] = t17;
    } else {
      t17 = $[32];
    }
    if ($[33] !== searchValue || $[34] !== t17) {
      t8 = <Command.Input value={searchValue} onValueChange={setSearchValue} onErase={close} placeholder={t17} autoFocus={true} />;
      $[33] = searchValue;
      $[34] = t17;
      $[35] = t8;
    } else {
      t8 = $[35];
    }
    t9 = (isError || searchValue.length >= MIN_SEARCH_LENGTH) && <Command.List className="flex flex-col gap-3 p-4">{isError && <div className="flex items-center justify-center py-8"><p className="text-body-2 text-error">{t(_temp3)}</p></div>}{!isError && searchValue.length >= MIN_SEARCH_LENGTH && results.length === 0 && <Command.Empty>{t(_temp4)}</Command.Empty>}{results.map(item => {
        const nodeInfo = getNodeInfo(item.nodeKind);
        return <Command.Item key={`${item.nodeId}:${item.matchingString}`} value={`${item.nodeId}:${item.matchingString}`} keywords={[item.nodeKind, item.matchingString]} onSelect={() => handleSelect(item.nodeId)} className="p-0 hover:bg-transparent data-[selected=true]:bg-transparent"><NodeCard icon={nodeInfo.icon} label={item.nodeName ?? nodeInfo.title.uppercase} subtitle={item.matchingString} onClick={() => handleSelect(item.nodeId)} className="w-full" /></Command.Item>;
      })}</Command.List>;
    $[6] = data;
    $[7] = getNodeInfo;
    $[8] = isError;
    $[9] = isOpen;
    $[10] = openNode;
    $[11] = searchValue;
    $[12] = t;
    $[13] = T0;
    $[14] = t10;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    T0 = $[13];
    t10 = $[14];
    t4 = $[15];
    t5 = $[16];
    t6 = $[17];
    t7 = $[18];
    t8 = $[19];
    t9 = $[20];
  }
  let t11;
  if ($[36] !== T0 || $[37] !== t4 || $[38] !== t5 || $[39] !== t6 || $[40] !== t7 || $[41] !== t8 || $[42] !== t9) {
    t11 = <T0 open={t4} onOpenChange={t5} shouldFilter={t6} className={t7}>{t8}{t9}</T0>;
    $[36] = T0;
    $[37] = t4;
    $[38] = t5;
    $[39] = t6;
    $[40] = t7;
    $[41] = t8;
    $[42] = t9;
    $[43] = t11;
  } else {
    t11 = $[43];
  }
  let t12;
  if ($[44] !== t10 || $[45] !== t11) {
    t12 = <>{t10}{t11}</>;
    $[44] = t10;
    $[45] = t11;
    $[46] = t12;
  } else {
    t12 = $[46];
  }
  return t12;
};
export default Search;
function _temp($) {
  return $.search.ariaLabel;
}
function _temp2($_0) {
  return $_0.search.placeholder;
}
function _temp3($_1) {
  return $_1.search.error;
}
function _temp4($_2) {
  return $_2.search.noResults;
}